export default "__VITE_ASSET__CmaIcopS__"